import React, { useState } from 'react';
import { FiPlayCircle, FiCamera, FiPlusCircle } from "react-icons/fi";
import '../../styles/GSIDA.css';

const mediaItems = [
  { id: 1, type: "photo", url: "https://via.placeholder.com/600x400/1b1e4f/ffffff?text=Congress+Photo+1", title: "Cérémonie d'Ouverture" },
  { id: 2, type: "video", url: "https://via.placeholder.com/600x400/000000/ffffff?text=GSIDA+Trailer", title: "Teaser GSIDA 2026" },
  { id: 3, type: "photo", url: "https://via.placeholder.com/600x400/c20e0f/ffffff?text=Congress+Photo+2", title: "Session Plénière" },
  { id: 4, type: "photo", url: "https://via.placeholder.com/600x400/1b1e4f/ffffff?text=Congress+Photo+3", title: "Ateliers Techniques" },
  { id: 5, type: "video", url: "https://via.placeholder.com/600x400/000000/ffffff?text=Round+Table", title: "Table Ronde : Innovation" },
  { id: 6, type: "photo", url: "https://via.placeholder.com/600x400/c20e0f/ffffff?text=Congress+Photo+4", title: "Cocktail Réseautage" },
];

export default function GSIDAGallery() {
  const [items, setItems] = useState(mediaItems.slice(0, 4));
  const [showAll, setShowAll] = useState(false);

  const toggleItems = () => {
    setShowAll(!showAll);
    if (!showAll) setItems(mediaItems);
    else setItems(mediaItems.slice(0, 4));
  };

  return (
    <div className="gsida-gallery-page">
      <div className="gsida-header-banner gallery-banner">
         <div className="banner-overlay">
            <h1>Médiathèque & Galerie</h1>
            <p>Revivre les Moments Forts du Congrès en Images et Vidéos</p>
         </div>
      </div>

      <div className="gsida-content-container">
        <div className="gallery-masonry-wrapper">
           <div className="media-grid">
              {items.map(m => (
                <div className={`media-item-box ${m.type}`} key={m.id}>
                   <img src={m.url} alt={m.title} />
                   <div className="media-overlay">
                      {m.type === 'video' ? <FiPlayCircle className="media-icon" /> : <FiCamera className="media-icon" />}
                      <h4>{m.title}</h4>
                   </div>
                </div>
              ))}
           </div>

           {!showAll && (
              <div className="gallery-fade-overlay">
                 <button className="see-more-btn" onClick={toggleItems}>
                    <FiPlusCircle /> Voir plus de médias
                 </button>
              </div>
           )}
           
           {showAll && (
              <div className="gallery-reset">
                 <button className="reset-btn" onClick={toggleItems}>Afficher moins</button>
              </div>
           )}
        </div>
      </div>
    </div>
  );
}
